/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { MotherhoodStandaloneEdge as ResolvedStandaloneEdge } from 'sites/motherhood/components/standalone/Edge';

export const Edge: typeof ResolvedStandaloneEdge = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneEdge {...props} />
    );
});

export type EdgeProps = PropsFromComponent<typeof Edge>;

/** @deprecated Use slot architecture instead */
export const EdgeWith = (extras: DynamicStandaloneExtras): typeof Edge => {
    return function Edge(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Edge');
        return <ResolvedStandaloneEdge {...mergeProps({ options: { theme } }, props)} />;
    }
}